var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wallet"},[_c('transition',{attrs:{"name":"snack-bar-slide-y"}},[_vm._t("snackbar")],2),_c('div',{staticClass:"wallet-settings-slot",style:(`
    ${_vm.$vuetify.breakpoint.smAndDown?'position: absolute;':'position: relative;'}
    ${_vm.$vuetify.breakpoint.smAndDown && !_vm.mobile_wallet_show_settings?'left: -100%;':'left: 0px;'}
    `)},[_vm._t("settings")],2),_c('div',{staticClass:"wallet-content-container",style:(_vm.$store.state.View.is_printing_mode?`height: ${_vm.getMaxHeight()}px !important;`:''),attrs:{"id":"wallet-content-container"}},[(!_vm.$vuetify.breakpoint.smAndDown)?_c('div',{staticClass:"wallet-column",style:(`
      z-index: ${_vm.$route.params.selected_column === 'left'?'1':'0'};
    `)},[_vm._t("left")],2):_vm._e(),_c('div',{staticClass:"wallet-column",style:(`
    width: ${!_vm.$vuetify.breakpoint.smAndDown?
      !_vm.is_micro_view ? 'calc((100vw - 50px) / 3)': '' :
        '100vw'};
    z-index: ${_vm.$route.params.selected_column === 'center'?'1':'0'};
    `)},[_vm._t("center")],2),(!_vm.$vuetify.breakpoint.smAndDown && !_vm.is_micro_view)?_c('div',{staticClass:"wallet-column",style:(`
      z-index: ${_vm.$route.params.selected_column === 'right'?'1':'0'};
    `)},[_vm._t("right")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }